import _assign from "object-assign";
import { base } from '@jpmuitk/style';
var defaultFontSize = 12;
export var style = function style(_ref) {
  var _ref$toolkit$palette = _ref.toolkit.palette,
      type = _ref$toolkit$palette.type,
      grey300 = _ref$toolkit$palette.grey300,
      grey60 = _ref$toolkit$palette.grey60;
  return {
    /* Styles applied to the root element */
    root: _assign({
      boxSizing: 'border-box',
      lineHeight: 1,
      display: 'inline-block',
      position: 'relative'
    }, base.iconFont, {
      color: type === 'dark' ? grey60 : grey300
    }),

    /* Styles applied to the content element */
    content: {
      display: 'block'
    },

    /* Styles applied to the root element if `size="small"` */
    small: {
      '& $content': {
        fontSize: defaultFontSize
      }
    },

    /* Styles applied to the root element if `size="medium"` */
    medium: {
      '& $content': {
        fontSize: defaultFontSize * 2
      }
    },

    /* Styles applied to the root element if `size="large"` */
    large: {
      '& $content': {
        fontSize: defaultFontSize * 2 * 2
      }
    }
  };
};